<template>
  <div class="text-start">
    <v-row no-gutters class="mb-4">
      <v-col>
        <span class="subtitle-1 font-weight-medium primary--text">
          {{ $t(`course.courseDetails.feedback`) }}
        </span>

        <v-divider class="my-2 primary" style="width: 100px" />
      </v-col>
    </v-row>

    <!--feedback questionAnswers-->
    <template v-if="questionAnswers && questionAnswers.length">
      <!--drag toggle switch-->
      <v-row v-if="isEditing && questionAnswers.length > 1" justify="end">
        <v-col cols="auto">
          <div class="d-flex align-center">
            <span class="body-1 font-weight-medium textLight--text px-3">
              {{ $t("reorder") }}
            </span>

            <v-switch
              v-model="isDraggingEnabled"
              inset
              flat
              hide-details
              class="ma-0"
              style="max-width: 44px"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <draggable
            v-model="questionAnswers"
            :disabled="!isEditing || !isDraggingEnabled"
            handle=".question-handle"
            @end="onDragEnd"
          >
            <v-row
              v-for="(questionAnswer, questionAnswerIndex) in questionAnswers"
              :key="`feedback-questionAnswer_${questionAnswerIndex}`"
              no-gutters
              class="mb-10"
            >
              <v-col>
                <FeedbackQuestionAnswer
                  :questionAnswer="questionAnswer"
                  :existingDisplayPositions="existingDisplayPositions"
                  :isEditing="isEditing && !isDraggingEnabled"
                  :selectedLocale="selectedLocale"
                  :isDraggable="isEditing && isDraggingEnabled"
                  @onUpdate="
                    updatedQuestionAnswer =>
                      updateFeedbackQuestionAnswers({
                        updatedQuestionAnswer,
                        questionAnswerIndex,
                      })
                  "
                  @onDelete="
                    updateFeedbackQuestionAnswers({
                      updatedQuestionAnswer: 'DELETE',
                      questionAnswerIndex,
                    })
                  "
                />
              </v-col>
            </v-row>
          </draggable>
        </v-col>
      </v-row>
    </template>

    <!--feedback questionAnswer add button-->
    <v-row v-if="isEditing && !isDraggingEnabled" no-gutters class="mt-12">
      <v-col>
        <v-btn
          depressed
          block
          color="button"
          class="
            subtitle-1
            font-weight-regular
            textLight--text
            text-capitalize
            rounded-lg
          "
          @click="addQuestionAnswer"
        >
          <v-icon left size="20">mdi-plus</v-icon>

          {{ $t("course.courseDetails.addNewQuestion") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import FeedbackQuestionAnswer from "@/app/feedback-module/components/details/FeedbackQuestionAnswer";

export default {
  name: "CourseFeedbackQuiz",
  components: { draggable, FeedbackQuestionAnswer },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      trainingFeedback: null,
      questionAnswers: null,
      isDraggingEnabled: false,
    };
  },
  computed: {
    existingDisplayPositions() {
      return (
        this.questionAnswers?.reduce((result, item) => {
          if (item.displayPosition != null) {
            result.push(item.displayPosition);
          }

          return result;
        }, []) ?? []
      );
    },
  },
  watch: {
    training: {
      immediate: true,
      handler() {
        this.trainingFeedback = this.training?.feedback
          ? this.training.feedback
          : {};

        this.questionAnswers = this.trainingFeedback?.questionAnswers ?? [];
      },
      deep: true,
    },
  },
  methods: {
    addQuestionAnswer() {
      this.questionAnswers.push({
        choices: [...Array(4).keys()].map(x => ({
          key: (x + 1).toString(),
          // hasInvalidChoice: true,
        })),
        // displayPosition: this.questionAnswers.length,//removed for dragging
        hasInvalidQuestion: true,
        // hasInvalidChoices: true,
      });

      this.emitUpdateTraining({
        feedback: {
          ...this.trainingFeedback,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInFeedback: true,
      });
    },
    updateFeedbackQuestionAnswers({
      updatedQuestionAnswer,
      questionAnswerIndex,
    }) {
      // console.log(this.questionAnswers);
      // console.log(updatedQuestionAnswer);
      if (updatedQuestionAnswer === "DELETE") {
        this.$dialog
          .confirm(
            this.$t(
              "course.courseDetails.confirmTrainingModuleContentQuestionDelete"
            )
          )
          .then(() => {
            this.questionAnswers.splice(questionAnswerIndex, 1);
          })
          .catch(_ => {});
      } else {
        // updatedQuestionAnswer.choices?.forEach(ch => {
        //   ch.hasInvalidChoice = !ch.value?.find(x => x.value?.trim()?.length);
        // });

        this.$set(this.questionAnswers, questionAnswerIndex, {
          ...updatedQuestionAnswer,
          hasInvalidQuestion: !updatedQuestionAnswer?.question?.find(
            x => x.value?.trim()?.length
          ),
        });
      }

      this.emitUpdateTraining({
        feedback: {
          ...this.trainingFeedback,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInFeedback: true,
      });
    },
    onDragEnd(evt) {
      this.emitUpdateTraining({
        feedback: {
          ...this.trainingFeedback,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInFeedback: true,
      });
    },
    emitUpdateTraining(obj) {
      const clonedTraining = { ...this.training, ...obj };
      this.$emit("update:training", clonedTraining);
    },
  },
};
</script>

<style lang="scss" scoped />
